jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	  //  $( document ).on( "variant:changed", function( evt ) {
	  //    console.log( evt.currentVariant );
	  //    $('[data-variant-toggle]').hide(0);
	  //    $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	  //  });
  // $( document ).on( "variant:changed", function( evt ) {
  //   // console.log( evt.currentVariant.id );
  //   fetch(`?variant=${evt.currentVariant.id}`).then(res=>res.text()).then((data)=>{
  //       const doc = new DOMParser().parseFromString(data, "text/html");
  //       const variant_tab_des = doc.querySelector('.sr4-tab-content_des')
  //       // console.log(variant_tab_des)
  //       document.querySelector('.sr4-tab-content_des').innerHTML = variant_tab_des.innerHTML
  //   }).catch(err=>console.log(err))
  // });

  $(document).on("variant:changed", function (evt) {

  const container = document.querySelector('.sr4-tab-content_des');

  // Loader show
  container.style.position = "relative";
  container.innerHTML = `
    <div class="variant-loader">
      Loading...
    </div>
  `;

  fetch(`?variant=${evt.currentVariant.id}`)
    .then(res => res.text())
    .then((data) => {
      const doc = new DOMParser().parseFromString(data, "text/html");
      const variant_tab_des = doc.querySelector('.sr4-tab-content_des');

      // Content replace
      container.innerHTML = variant_tab_des.innerHTML;
    })
    .catch(err => {
      console.log(err);
      container.innerHTML = `<p>Error loading data</p>`;
    });

});
document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
  ele.addEventListener("input", function () {
    if (this.value < 0) {
        this.value = 0;
    }
  });
});

  
const cartFusionVariantPre = document.querySelector(`.cartFusion_fbt_item select option[value="${window.location.search.split('=').pop()}"]`);
if (cartFusionVariantPre) {
  cartFusionVariantPre.selected = true;

  if (cartFusionVariantPre.disabled === true) {
    // console.log('soldout')
    document.querySelector('.cartFusion_fbt_action_control').style.display = 'none';
    document.querySelector('.cartFusion_fbt_action_trigger').style.display = 'none';
    document.querySelector('.soldOutButton').removeAttribute('hidden');
  } else {
    // console.log('instock')
    document.querySelector('.cartFusion_fbt_action_control').style.display = 'block';
    document.querySelector('.cartFusion_fbt_action_trigger').style.display = 'block';
    document.querySelector('.soldOutButton').setAttribute('hidden', '');
  }
}

$( document ).on( "variant:changed", function( evt ) {
// document.querySelector(.cartFusion_fbt_item select option[value="${evt.currentVariant.id}"]).selected = true;
const cartFusionVariant = document.querySelector(`.cartFusion_fbt_item select option[value="${evt.currentVariant.id}"]`);

if (cartFusionVariant) {
  cartFusionVariant.selected = true;

  if (cartFusionVariant.disabled === true) {
    // console.log('soldout')
    document.querySelector('.cartFusion_fbt_action_control').style.display = 'none';
    document.querySelector('.cartFusion_fbt_action_trigger').style.display = 'none';
    document.querySelector('.soldOutButton').removeAttribute('hidden');
  } else {
    // console.log('instock')
    document.querySelector('.cartFusion_fbt_action_control').style.display = 'block';
    document.querySelector('.cartFusion_fbt_action_trigger').style.display = 'block';
    document.querySelector('.soldOutButton').setAttribute('hidden', '');
  }
}

// 1. Select the specific option
const targetOption = document.querySelector(`.sr4-product-form__buttons.dynamic_checkout select option[value="${evt.currentVariant.id}"]`);

if (targetOption) {
    const selectElement = targetOption.parentElement;
    const productForm = selectElement.closest('form');
    // Find the submit button within this specific form
    const submitButton = document.querySelector('.sr4-product-form__buttons.dynamic_checkout button.shopify-payment-button__button');

    // 1. Set the selection
    targetOption.selected = true;

    // 2. Dispatch change event for internal logic
    selectElement.dispatchEvent(new Event('change', { bubbles: true }));

    // 3. Handle the "Sold Out" state
    if (targetOption.classList.contains('is--sold-out')) {
        submitButton.disabled = true;
        submitButton.textContent = "Sold Out"; // Optional: Update button text
    } else {
        submitButton.disabled = false;
        submitButton.textContent = "BUY IT NOW"; // Optional: Reset button text
    }
} else {
    console.error("Option not found for variant ID:", evt.currentVariant.id);
}
});

$(document).on("variant:changed", function (evt) {
  // console.log(evt.currentVariant.title);
  if (evt.currentVariant.title.includes('Customised')) {
      document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
          ele.removeAttribute("disabled");
      });
      document.querySelectorAll(`.cartFusion_fbt_wrapper input.fbt_properties.customize_properties`).forEach((cartFusionPro)=>{
          cartFusionPro.removeAttribute("disabled");
      })
    } else {
      document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
        ele.setAttribute("disabled", "disabled");
      });
      document.querySelectorAll(`.cartFusion_fbt_wrapper input.fbt_properties.customize_properties`).forEach((cartFusionPro)=>{
          cartFusionPro.setAttribute("disabled", "disabled");
      })
  };
});
document.querySelectorAll('#CustomSizeTab input').forEach((inp)=>{
    inp.addEventListener('input',()=>{
        document.querySelector(`.cartFusion_fbt_wrapper input[id="${inp.id}"]`).value = inp.value;
    })
})
const checkboxes = document.querySelectorAll('.cartFusion_fbt_item input[type="checkbox"]');

checkboxes.forEach((checkbox, index) => {
  checkbox.addEventListener('change', function(e) {
    // 1. Prevent the infinite loop
    // isTrusted is true if a human clicked it. 
    // If we triggered it via code, we don't want to run this logic again.
    if (!e.isTrusted && e.detail !== "programmatic") return;

    // 2. Mutual Exclusion Logic (Stitching Options)
    if (index === 1 && this.checked) {
      const other = checkboxes[2];
      if (other && other.checked) {
        other.checked = false;
        // Trigger change on the OTHER box so the price app sees it
        other.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: "programmatic" }));
      }
    }

    if (index === 2 && this.checked) {
      const other = checkboxes[1];
      if (other && other.checked) {
        other.checked = false;
        // Trigger change on the OTHER box so the price app sees it
        other.dispatchEvent(new CustomEvent('change', { bubbles: true, detail: "programmatic" }));
      }
    }
  });
});

})